import { defineAsyncComponent } from "vue";

const staticRoute = [
  {
    path: "/login",
    name: "login",
    component: defineAsyncComponent(() => import("@/views/login/index.vue"))
  },
  {
    path: "/app",
    name: "app",
    component: defineAsyncComponent(() => import("@/views/app/download.vue"))
  },
  {
    path: "/register",
    name: "register",
    component: defineAsyncComponent(() => import("@/views/register/index.vue"))
  },
  {
    path: "/users",
    name: "users",
    component: defineAsyncComponent(() => import("@/views/register/users.vue"))
  },
  {
    path: "/privacy",
    name: "privacy",
    component: defineAsyncComponent(() => import("@/views/register/privacy.vue"))
  },
  {
    path: "/registerSuccess",
    name: "registerSuccess",
    component: defineAsyncComponent(() => import("@/views/register/registerSuccess.vue"))
  },
  {
    path: "/sign",
    name: "sign",
    component: defineAsyncComponent(() => import("@/views/sign/index.vue"))
  },
  {
    path: "/signSuccess",
    name: "signSuccess",
    component: defineAsyncComponent(() => import("@/views/sign/signSuccess.vue"))
  },
  {
    path: "/signTest",
    name: "signTest",
    component: defineAsyncComponent(() => import("@/views/sign/signTest.vue"))
  },
  {
    path: '/redirect',
    name: "hyzx",
    component: defineAsyncComponent(() => import("@/views/hyzx/index.vue")),
    children: [
        {
          path: '/redirect/:path(.*)',
          component: () => import('@/views/redirect')
        }
    ]
  }
]
export default staticRoute
